import { z } from 'zod'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { useQueryRequest } from '~/ui/hooks/utils'

import { balanceSchema } from './definitions'

const MarketBuybackOfferResponseSchema = z.object({
  buybackOfferId: z.string(),
  expiresAt: z.string(),
  offerReferenceDate: z.string(),
  buybackBalance: balanceSchema,
  discountBalance: balanceSchema,
  remainingBalance: balanceSchema
})

export type MarketBuybackOfferResponse = z.infer<typeof MarketBuybackOfferResponseSchema>

async function fetchMarketBuybackOffer({
  accountId,
  productId,
  amount
}: {
  accountId: string
  productId: string
  amount: number
}) {
  const { data } = await httpClientBanking({
    url: `/investments/accounts/${accountId}/storefront/products/${productId}/buyback/offer`,
    method: 'GET',
    params: { amount }
  })

  return MarketBuybackOfferResponseSchema.parse(data)
}

export function getUseFetchMarketBuybackOfferKey(accountId: string, productId: string, amount: number) {
  return ['useFetchMarketBuybackOffer', accountId, productId, amount] as const
}

export function useFetchMarketBuybackOffer({
  accountId,
  productId,
  amount
}: {
  accountId: string
  productId: string
  amount: number
}) {
  return useQueryRequest<MarketBuybackOfferResponse, unknown, true>(
    getUseFetchMarketBuybackOfferKey(accountId, productId, amount),
    () => fetchMarketBuybackOffer({ accountId, productId, amount }),
    {
      enabled: Boolean(accountId && productId && amount > 0),
      suspense: false,
      retry: false
    }
  )
}
